<script setup lang="ts">
import ProtectedButton from 'pejer/src/components/ProtectedButton.vue'
import { ApiUrls } from 'pejer/src/types/base'
import { useForwardPropsEmits } from 'radix-vue'
import { HTMLAttributes, MaybeRef } from 'vue'
import { DataState } from '../../types/types'
import DataStateDisplay from '../DataState/DataStateDisplay.vue'
import DataStateError from '../DataState/DataStateError.vue'
import DataStateLoading from '../DataState/DataStateLoading.vue'
import Button, { ButtonProps } from '../ui/button/Button.vue'

const props = defineProps<
  {
    class?: string
    errorClass?: HTMLAttributes['class']
    type?: string
    dataState: DataState
    url?: ApiUrls<any>
    disabled?: MaybeRef<boolean>
  } & Omit<ButtonProps, 'disabled'>
>()
const { dataState: _, ...attrs } = props

const emits = defineEmits<{
  (e: 'click'): void
}>()
const forwardedAttributes = useForwardPropsEmits(attrs, emits)
</script>
<template>
  <DataStateDisplay
    :isError="dataState.isError"
    :error="dataState.error"
    :isLoading="dataState.isLoading"
    :showSlot="true"
  >
    <template #error>
      <slot name="error">
        <DataStateError :error="dataState.error" isAction :class="errorClass">
          <Button v-bind="forwardedAttributes" :disabled="disabled">
            <slot />
          </Button>
        </DataStateError>
      </slot>
    </template>
    <template #loading>
      <slot name="loading">
        <Button v-bind="forwardedAttributes" disabled>
          <slot /> <DataStateLoading hideText />
        </Button>
      </slot>
    </template>
    <Button v-bind="forwardedAttributes" :disabled="disabled" v-if="!url">
      <slot />
    </Button>
    <ProtectedButton v-bind="forwardedAttributes" v-else>
      <slot />
    </ProtectedButton>
  </DataStateDisplay>
</template>
